// The bundle (through Shepherd's deepmerge-ts) calls Array.prototype.at and Object.hasOwn,
// which Safari only shipped in 15.4 while the iOS app still supports iOS 15.0.
// Imported first in index.js so they exist before any other module runs.

if (!Array.prototype.at) {
  // eslint-disable-next-line no-extend-native -- a standard method, added only where it's missing
  Object.defineProperty(Array.prototype, "at", {
    value: function at(index) {
      const length = this.length >>> 0;
      let i = Math.trunc(index) || 0;
      if (i < 0) i += length;
      return i < 0 || i >= length ? undefined : this[i];
    },
    writable: true,
    configurable: true,
  });
}

if (!Object.hasOwn) {
  Object.defineProperty(Object, "hasOwn", {
    value: (object, key) => Object.prototype.hasOwnProperty.call(Object(object), key),
    writable: true,
    configurable: true,
  });
}
